<template>
  <div class="fillcontain">
    <top-header></top-header>
    <div class="search_container">
      <span style="padding: 0px">选择时间</span>
      <el-date-picker
        v-model="dateValue"
        type="datetimerange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['8:00:00','20:00:00']">
      </el-date-picker>
      <el-button type="primary" style="padding-left: 20px" @click="searchBtnClick">搜索</el-button>
    </div>
    <div class="table_container">
      <el-table
        :data="dataList"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        style="width: 100%">
        <el-table-column
          label="流水号"
          prop="Id">
        </el-table-column>
        <el-table-column
          label="充值时间">
          <template scope="props">
            <p> {{props.row.CreateTime}}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="充值金额"
          prop="Fee">
        </el-table-column>
        <el-table-column
          label="充值渠道">
          <template scope="props">
            <p> {{formatPayWay(props.row.Way)}}</p>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import TopHeader from '../../components/TopHeader'
  export default {
    name: 'RechargeRecord',
    components: {TopHeader},
    data () {
      return {
        dataList: [],
        searchValue: '',
        dialogFormVisible: false,
        dateValue: [],
        currentPage: 1,
        pageCount: 10,
        totalCount: 0
      }
    },
    created () {
      this.searchBtnClick()
    },
    watch: {
      '$route': {
        handler (route) {
          const that = this
          if (route.path === '/rechargerecord') {
            console.log('----', route.path)
            that.searchBtnClick()
          }
        },
        deep: true
      }
    },
    methods: {
      searchBtnClick () {
        if (this.dateValue !== undefined && this.dateValue !== null && this.dateValue.length > 1) {
          let startTime = this.formatDate('YYYY-mm-dd HH:MM:SS', this.dateValue[0])
          let endTime = this.formatDate('YYYY-mm-dd HH:MM:SS', this.dateValue[1])
          let requestData = {begints: startTime, endts: endTime, page: this.currentPage, count: this.pageCount}
          console.log(requestData)
          this.$api.recharge.getRechargeRecordBySearch(requestData).then((res) => {
            if (res.code === 0) {
              this.dataList = res.data
              this.totalCount = res.count
            }
          })
          console.log(startTime)
        } else {
          let requestData = {page: this.currentPage, count: this.pageCount}
          console.log(requestData)
          this.$api.recharge.getRechargeRecord(requestData).then((res) => {
            if (res.code === 0) {
              this.dataList = res.data
              this.totalCount = res.count
            }
          })
        }
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this.searchBtnClick()
      },
      handleSizeChange (val) {
        this.pageCount = val
        this.currentPage = 1
        this.searchBtnClick()
      },
      formatPayWay (way) {
        if (way === 'alipay') {
          return '支付宝'
        } else if (way === 'wechatpay') {
          return '微信支付'
        } else if (way === 'bank') {
          return '银行转账'
        }
      },
      formatDate (fmt, dateStr) {
        let date = new Date(dateStr)
        let ret
        let opt = {
          'Y+': date.getFullYear().toString(),
          'm+': (date.getMonth() + 1).toString(),
          'd+': date.getDate().toString(),
          'H+': date.getHours().toString(),
          'M+': date.getMinutes().toString(),
          'S+': date.getSeconds().toString()
        }
        for (let k in opt) {
          ret = new RegExp('(' + k + ')').exec(fmt)
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
          };
        };
        return fmt
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../style/mixin-bak";
  .search_container{
    width: 100%;
    padding-top: 10px;
    text-align: center;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    text-align: justify;
    margin-right: 0;
    margin-bottom: 0;
    width: 30%;
  }
  .table_container{
    padding: 20px;
  }
  .Pagination{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/page/financedManager/RechargeRecord.vue